import Constants from '../config/const';
import { saveWall } from './save_wall';

export const redo = (action) => ({
  type: Constants.undo.push,
  action
});

export const undo = () => (dispatch, getState) => {
  const { undos } = getState();
  if (undos.length) {
    const action = undos[undos.length - 1];
    dispatch({
      type: Constants.undo.pop
    });
    dispatch(action);
    dispatch(saveWall());
  }
};
